/**
 * Card number input used for adding a card
 *
 * Dependent on getCardSpecs() from https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js,
 * but you could just supply an object of specifications similar to what getCardSpecs returns.
 */
import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { StyleSheet, css } from 'aphrodite';
import TextInput from 'react-text-input';

import { cardSpecsPropType, cardSpecPropType } from 'prop-validators';
import { defaultCardSpec, getSpecificCardSpec } from '../utility/card-utils';

const STYLES = StyleSheet.create({
	logoWrapper: {
		height: '100%',
		position: 'absolute',
		top: 0,
		right: 0
	},
	dropdown: {
		padding: 0,
		textIndent: 12,
		boxSizing: 'content-box',
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none',
		'@-moz-document url-prefix()': {
			textIndent: 2.5,
		},
		'::-ms-expand': { display: 'none' },
	},
	arrow: {
		position: 'absolute',
		right: 10,
		top: 20,
		cursor: 'default',
		pointerEvents: 'none'
	},
	logo: {
		display: 'inline-block',
		marginTop: 12,
		marginRight: 2
	},
	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
});

class CardType extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			cardType: '',
			cardTypeErrorMessage: '',
			showIsRequiredError: false,
			cardType: this.props.cardType || '',
		};
	}

	/*
	* Handle card type change
	*/
	handleChange = (event) => {
		const { cardSpecs: {cardTypes = {}} } = this.props
		let value = event.target.value;
		this.setState({ cardType: value });
		this.props.changeCardType(value);

		Object.entries(cardTypes).map(([key, item]) => {
			if(item.type === value){
				this.props.changeCardType(item)
			}
		})
	}

	render() {
		const {cardSpecs: { cardTypes = {}}, errorMessage} = this.props
		let { cardTypeErrorMessage } = this.state;
		let errorMessageClassNames = classNames(css(STYLES.errorMessage), {
			'vx_form-control-message': errorMessage || cardTypeErrorMessage
		});
		let errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage || cardTypeErrorMessage) {
			errorStyles = { height: '100%' };
		}

		return(
			<div className={classNames({
				'vx_has-error-with-message': errorMessage,
				'vx_has-error': errorMessage,
				})} style={{ margin: '10px 0 0', position: 'relative' }}>
				<div style={{ position: 'relative', marginTop: 10 }}>
					<select id="cardTypeSelection"
							className={`vx_form-control vx_form-control_complex ${css(STYLES.dropdown)}`}
							value={this.state.cardType}
							onChange={this.handleChange}>
							<option value="" disabled>{this.props.label}</option>
							{Object.entries(cardTypes).map(([key, value]) => (
								<option key={value.type} value={value.type}>{value.name}</option>
							))}
					</select>
					<label htmlFor="cardTypeSelection" className={`icon icon-arrow-down-small ${css(STYLES.arrow)}`}></label>
					{/* show the error message if it exists */}
					<div className={errorMessageClassNames} style={errorStyles}>{errorMessage || cardTypeErrorMessage}</div>
				</div>
			</div>
		)
	}
};

CardType.propTypes = {
	changeCardType: PropTypes.func.isRequired
};

export { defaultCardSpec };
export default CardType;



// WEBPACK FOOTER //
// ./components/card-type.js